import React, { } from 'react';
import { useDispatch } from 'react-redux';
import {
  userActions,
} from '../../redux/actions';

import { SideForm } from '../SideForms/SideForm';

import {
  TextInput,
  PasswordInput,
  Form,
  FormGroup,
  TextInputSkeleton,
  TextAreaSkeleton,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Link,
  Column,
  Row,
  Select,
  SelectItem,
  FormLabel,
  Checkbox,
  Loading
} from '@carbon/react';

import useUser from '@/lib/hooks/useUser';
import {
  useLazyGetUserQuery,
  useUpdateUserMutation,
  useCreateUserMutation,
} from 'services/user';
import useForm from '@/lib/hooks/useForm';
import SelectableOrganisation from '../Organisation/OrganisationSelection';


const SelectRole = ({ isChangable, onChange, value = 0, error_state, isAdmin = false }) => {
  if (isChangable) {
    const items = [
      { id: 1, text: 'Administrator' },
      { id: 2, text: 'Benutzer' },
      { id: 3, text: 'Mitbenutzer' },
    ];

    if (!isAdmin) {
      items.splice(0, 1);
    }

    return (
      <Select
        id="role-selection"
        labelText={'Welche Rolle hat der Benutzer'}
        value={value}
        onChange={(e) => onChange('RoleID', Number(e.currentTarget.value))}
        data-field="mode"
        data-valuetype="string">
        <SelectItem text="Rolle wählen..." value={0} />
        {items.map((i) => {
          return (
            <SelectItem
              key={`role-selection_item_${i.id}`}
              text={i.text}
              value={i.id}
              //selected={}
            />
          );
        })}
      </Select>
    );
  }

  return <></>;
};

const UserForm = ({ id }) => {

  //const [confirmRemoveUser] = useModal('DELETE_USER');

  const [updateUser, { isLoading: isUpdating }] = useUpdateUserMutation();
  const [createUser, { isLoading: isCreating }] = useCreateUserMutation();

  const {item: stateItem, onChangeField, onSaveRequest, onCloseForm, unsaved, loading} = useForm({
    id,
    getLazy: useLazyGetUserQuery,
    updateMutation: updateUser,
    createMutation: createUser,
    //deleteMutation: useDeleteUserMutation,

    defaultValues: {
      firstname: '',
      lastname: '',
      email: '',
      ParentUserID: 0,
      OrganisationID: 0,
      additional_licences: 0,
      max_element_space: 1024,
      inform_user: false,
      auto_password: true,
    }
  });

  const { isAdmin, isOwner, userID } = useUser();


  /*const onSaveRequest = () => {
    if (unsaved === true) {
      console.info('Want to save this:', stateItem);
      //save(stateItem);
      updateUser({id: stateItem.model.ID, form: stateItem}).unwrap()
        .then((result) => {
          console.info("update result:", result);
          dispatch(showToast({kind: "success", title: "Änderungen gespeichert", caption: "Benutzer wurde gespeichert."}));
          setUnsaved(false);
        })
        .catch((error) => {

        });
    } else {
      dispatch(hideForm());
    }
  };*/

  const remove = (user) => {
    //confirmRemoveUser({ user })
  };

  let tabs = <></>;

  if (loading) {
    tabs = (

      <Tabs type="container">
        <TabList contained aria-label="">
          <Tab className="tab-content">
            Benutzer Profil
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <Form>
              <FormGroup legendText="">
                <TextInputSkeleton />
              </FormGroup>
              <FormGroup legendText="">
                <TextAreaSkeleton />
              </FormGroup>
            </Form>
          </TabPanel>
        </TabPanels>

      </Tabs>
    );
  } else {
    tabs = (
      <Tabs type="container">
        <TabList contained aria-label="">
          <Tab id="tab_default">
            Benutzer Profil
          </Tab>
          <Tab id="tab_advanced">
            Erweitert
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel className="tab-content">
            <Form>
              <FormGroup legendText="">
                <TextInput
                  labelText="Mail Adresse"
                  value={stateItem.email}
                  id="form_user_email"
                  onChange={(e) => onChangeField(['email'], e.target.value)}
                  invalid={
                    stateItem.email.length < 4 ||
                    !stateItem.email.includes('@') ||
                    !stateItem.email.includes('.')
                  }
                  invalidText={
                    'E-Mail Adresse ist ungültig'
                  }
                />
                <br />

                <Row>
                  <Column>
                    <TextInput
                      labelText="Vorname"
                      value={stateItem.firstname}
                      id="form_user_firstname"
                      invalid={stateItem.firstname.length < 2}
                      invalidText={
                        'Vorname wird benötigt und darf nicht leer sein.'
                      }
                      onChange={(e) =>
                        onChangeField(['firstname'], e.target.value)
                      }
                    />
                  </Column>
                  <Column>
                    <TextInput
                      labelText="Nachname"
                      value={stateItem.lastname}
                      id="form_user_lastname"
                      invalid={stateItem.lastname.length < 2}
                      invalidText={
                        'Nachname wird benötigt und darf nicht leer sein.'
                      }
                      onChange={(e) =>
                        onChangeField(['lastname'], e.target.value)
                      }
                    />
                  </Column>
                </Row>

                {isAdmin && (
                  <FormLabel>Zuordnung zur Organisation</FormLabel>
                )}
                {isAdmin && (
                  <SelectableOrganisation
                    selection={[stateItem.OrganisationID]}
                    onSelectionChange={(id) => onChangeField(['OrganisationID'], id[0])}
                  />
                )}
                <SelectRole
                  isChangable={
                    (isAdmin || isOwner) && stateItem.model.ID !== userID
                  }
                  isAdmin={isAdmin}
                  value={stateItem.RoleID}
                  onChange={onChangeField}
                />

                {stateItem.model.ID === 'new' && (
                  <>
                    <br />
                    <hr />

                    <PasswordInput
                      labelText="Passwort"
                      value={stateItem.password || ''}
                      id="form_user_password"
                      autoComplete="off"
                      disabled={stateItem.auto_password}
                      invalid={(stateItem.password?.length ?? 0) < 6}
                      invalidText={
                        'Das Passwort muss mindestens 6 Zeichen lang sein'
                      }
                      onChange={(e) =>
                        onChangeField(['password'], e.target.value)
                      }
                    />

                    <Checkbox
                      labelText="Passwort Automatisch festlegen"
                      id="form_user_password_automatic"
                      value={stateItem.auto_password}
                      checked={stateItem.auto_password}
                      onChange={(_, {checked}) => onChangeField(['auto_password'], checked)}
                    />

                    <br />
                    <Checkbox
                      labelText="Soll der Benutzer über die Erstellung des Kontos informiert werden?"
                      id="form_user_inform"
                      value={stateItem.inform_user}
                      onChange={(_, {checked}) => onChangeField(['inform_user'], checked)}
                    />
                  </>
                )}
              </FormGroup>
            </Form>
          </TabPanel>
        </TabPanels>

      </Tabs>
    );
  }

  return (
    <SideForm
      title={id === 'new' ? 'Neuer Benutzer' : (loading ? '...' : stateItem?.email)}
      subTitle="Benutzer bearbeiten"
      onClose={onCloseForm}
      onSubmit={onSaveRequest}
      primaryButton={'Speichern'}
      primaryButtonDisabled={!unsaved}
      secondaryButton={
        unsaved === true ? 'Abbruch' : 'Verlassen'
      }>
      {tabs}
      {(loading || isUpdating || isCreating) && <Loading />}
    </SideForm>
  );
};

export default UserForm;
